<!-- ========================== intro (start) ========================== -->
    <div class="dashboard-wrapper" [formGroup]="nt.NTForm">
        <div class="dashboard-section-wrapper">
      
            <section class="dashboard-section">
                <header class="dashboard-section-header">
                    <h2>Fetus Measurments</h2>
                    <div class="dashboard-section-status">
                        <span></span>
                        <span></span>
                        <span class="active">Normal</span>
                        <span></span>
                        <span></span>
                    </div>
                </header>
                <div class="measurement-container fww measurments-panel ntmeas" style="z-index: -5;">
                    <app-measure MyMeasure="GS"  [Editable]="true" class="measurment-unit" style='margin-right: 9em' [updated]="nt.updated$.asObservable()"></app-measure>
                    <app-measure MyMeasure="CRL"  [Editable]="true" class="measurment-unit" style="margin-right: 7em;" [updated]="nt.updated$.asObservable()"></app-measure>
                    <app-measure MyMeasure="NT"  [Editable]="true" class="measurment-unit"  style='margin-right: 4em;' [updated]="nt.updated$.asObservable()"></app-measure>
                </div>
            </section>
            
        </div>
        <div class="dashboard-section-wrapper">
            <section class="dashboard-section"  style="padding: 20px 24px;margin-bottom: 15px;">
                <header class="dashboard-section-header">
                    <h2>Biophysical Indices</h2>
                </header>
                <div class="l-flex-c cervical-row-2">
                    <label class="l-fg1 cervical-label" id="">Yolk Sac</label>
                    <div class="l-flex-c t-field t-twin-fieldset t-field--number">
                        <app-genradio formname="YolkSac" [formgroup]="nt.NTForm" [value1]="0" [value2]="1" lname="Yes" rname="No" [resetval]="-1"></app-genradio>
                    </div>
                </div>
                <div class="l-flex-c cervical-row-2">
                    <label class="l-fg1 cervical-label" id="">Nasal Bone</label>
                    <div class="l-flex-c t-field t-twin-fieldset t-field--number">
                        <app-genradio formname="NasalBone" [formgroup]="nt.NTForm" [value1]="0" [value2]="1" lname="Yes" rname="No" [resetval]="-1"></app-genradio>
                    </div>
                </div>
                <div class="l-flex-c cervical-row-2">
                    <label class="l-fg1 cervical-label" id="">Heart Beat</label>
                    <div class="l-flex-c t-field t-twin-fieldset t-field--number">
                        <app-genradio formname="Heart" [formgroup]="nt.NTForm" [value1]="0" [value2]="1" lname="Yes" rname="No" [resetval]="-1"></app-genradio>
                    </div>
                </div>
                <div class="l-flex-c cervical-row-2">
                    <label for="" class="l-fg1 cervical-label">FHR</label>
                    <span class="t-field t-field--number">
                        <input class="t-field-text" type="number" min="0" id="" formControlName="FHR"/>
                        <span class="t-field-desc">bpm</span>
                    </span>
                </div>
               
            </section>

            <div class="w100 summary">
                <div class="m-box doppler-comments">
                    <h2>
                        Comments
                    </h2>
                    
                        <textarea class="full" formControlName="Comments" formControlName="Comments"></textarea>
                        <button class="t-btn-edit" *ngIf="! es.isClosed" (click)="atS.showAuto(nt.NTForm.get('Comments'),(es.ExamType=='NT'? 'NT': '1st Trimester') + ' Comments',60)">Auto Text</button>		
                        
                </div>
            </div>
        </div>
    </div>

    <div class="second-layer-popup">
        <div class="second-layer-popup-frame">
            <div class="second-layer-popup-body"></div>
        </div>
    </div>
